import { hasAnalyticsConsent } from "@/lib/consent";

const STORAGE_KEY = "content-views-session";

export type ContentType = "article" | "instagram" | "podcast";

function seen(): Set<string> {
  if (typeof window === "undefined") return new Set();
  try {
    const raw = window.sessionStorage.getItem(STORAGE_KEY);
    return new Set(raw ? (JSON.parse(raw) as string[]) : []);
  } catch {
    return new Set();
  }
}

function persist(ids: Set<string>) {
  try {
    window.sessionStorage.setItem(STORAGE_KEY, JSON.stringify([...ids]));
  } catch {
    /* stockage indisponible : on ignore */
  }
}

/** Enregistre une vue de contenu, une seule fois par contenu et par session. */
export function recordContentView(contentType: ContentType, contentId: string | undefined) {
  if (!contentId || typeof window === "undefined") return;
  // RGPD : aucune mesure d'audience sans consentement explicite.
  if (!hasAnalyticsConsent()) return;
  const key = `${contentType}:${contentId}`;
  const ids = seen();
  if (ids.has(key)) return;
  ids.add(key);
  persist(ids);
  void fetch("/api/public/track-view", {
    method: "POST",
    headers: { "content-type": "application/json" },
    body: JSON.stringify({ contentId, contentType }),
  })
    .then((res) => {
      if (!res.ok) throw new Error(String(res.status));
    })
    .catch(() => {
      // Échec (erreur réseau ou limite de débit) : on autorise une nouvelle
      // tentative plus tard dans la session.
      const current = seen();
      current.delete(key);
      persist(current);
    });
}
